import {
    USER_SEGMENTS_REQUESTED,
    USER_SEGMENTS_SUCCEEDED,
    USER_SEGMENTS_FAILED,
    SET_ACTIVE_SEGMENT,
    SEGMENT_TAGS_REQUESTED,
    SEGMENT_TAGS_SUCCEEDED,
    SEGMENT_TAGS_FAILED,
    MORE_USER_SEGMENTS_REQUESTED,
    RESET_USER_SEGMENTS,
    RESET_USER_SEGMENTS_TAGS,
    SEGMENT_PHOTOS_REQUESTED,
    SEGMENT_PHOTOS_SUCCEEDED,
    SEGMENT_PHOTOS_FAILED,
    UPDATE_SEGMENT_NOTES_REQUESTED,
    UPDATE_SEGMENT_NOTES_SUCCEEDED,
    UPDATE_SEGMENT_NOTES_FAILED,
    DELETE_SEGMENT_REQUESTED,
    DELETE_SEGMENT_SUCCEEDED,
    DELETE_SEGMENT_FAILED,
    UPDATE_SEGMENT_NAME_SUCCEEDED,
    UPDATE_SEGMENT_NAME_FAILED,
    PARTNERS_REQUESTED,
    PARTNERS_SUCCEEDED,
    PARTNERS_FAILED,
} from './constants';

export function userSegmentsRequested(data, attributeName = 'date') {
    return {
        type: USER_SEGMENTS_REQUESTED,
        data,
        attributeName,
    };
}

export function moreUserSegmentsRequested() {
    return {
        type: MORE_USER_SEGMENTS_REQUESTED,
    };
}

export function userSegmentsSucceeded(segments) {
    return {
        type: USER_SEGMENTS_SUCCEEDED,
        segments,
    };
}

export function userSegmentsFailed(error) {
    return {
        type: USER_SEGMENTS_FAILED,
        error,
    };
}

export function segmentTagsRequested(segmentTaxonomy, segmentId) {
    return { type: SEGMENT_TAGS_REQUESTED, segmentTaxonomy, segmentId };
}

export function segmentTagsSucceeded(segmentTags) {
    return {
        type: SEGMENT_TAGS_SUCCEEDED,
        segmentTags,
    };
}

export function segmentTagsFailed(error) {
    return {
        type: SEGMENT_TAGS_FAILED,
        error,
    };
}

export function setActiveSegment(activeSegmentId) {
    return {
        type: SET_ACTIVE_SEGMENT,
        activeSegmentId,
    };
}

export function resetUserSegments() {
    return {
        type: RESET_USER_SEGMENTS,
    };
}
export function resetUserSegmentsTags() {
    return {
        type: RESET_USER_SEGMENTS_TAGS,
    };
}

export function segmentPhotosRequested(segmentId, userId) {
    return { type: SEGMENT_PHOTOS_REQUESTED, segmentId, userId };
}

export function segmentPhotosSucceeded(segmentPhotos) {
    return {
        type: SEGMENT_PHOTOS_SUCCEEDED,
        segmentPhotos,
    };
}

export function segmentPhotosFailed(error) {
    return {
        type: SEGMENT_PHOTOS_FAILED,
        error,
    };
}

export function updateSegmentNotesRequested(segmentId, notes) {
    return { type: UPDATE_SEGMENT_NOTES_REQUESTED, segmentId, notes };
}

export function updateSegmentNotesSucceeded(segment) {
    return {
        type: UPDATE_SEGMENT_NOTES_SUCCEEDED,
        segment,
    };
}

export function updateSegmentNotesFailed(error) {
    return {
        type: UPDATE_SEGMENT_NOTES_FAILED,
        error,
    };
}

export function updateSegmentNameSucceeded(segment) {
    return {
        type: UPDATE_SEGMENT_NAME_SUCCEEDED,
        segment,
    };
}

export function updateSegmentNameFailed(error) {
    return {
        type: UPDATE_SEGMENT_NAME_FAILED,
        error,
    };
}

export function deleteSegmentRequested(segmentId) {
    return { type: DELETE_SEGMENT_REQUESTED, segmentId };
}

export function deleteSegmentSucceeded(segmentId) {
    return {
        type: DELETE_SEGMENT_SUCCEEDED,
        segmentId,
    };
}

export function deleteSegmentFailed(error) {
    return {
        type: DELETE_SEGMENT_FAILED,
        error,
    };
}

export function partnersRequested() {
    return {
        type: PARTNERS_REQUESTED,
    };
}

export function partnersSucceeded(partners) {
    return {
        type: PARTNERS_SUCCEEDED,
        partners,
    };
}

export function partnersFailed(error) {
    return {
        type: PARTNERS_FAILED,
        error,
    };
}
